export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-hearts-line' },
  { slug: 'gl', name: 'GL', icon: 'ri-heart-pulse-line' },
  { slug: 'daily', name: '日常', icon: 'ri-sun-line' },
];

export const comics = [
  {
    id: 'secret-relationship',
    title: '秘密关系',
    slug: 'secret-relationship',
    author: '李多喜',
    category: 'romance',
    status: '连载中',
    rating: 9.6,
    views: 1250000,
    chapters: 87,
    updatedAt: '2026-08-05',
    description: '她以为只是一场普通的办公室恋情，没想到对方竟是公司新来的CEO。两人在电梯里的偶遇，让她的生活彻底改变。甜蜜又刺激的秘密关系，能否修成正果？一段隐藏在职场背后的浪漫故事就此展开。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%2C%20beautiful%20couple%20in%20modern%20office%20setting%2C%20warm%20romantic%20atmosphere%2C%20soft%20lighting%2C%20delicate%20illustration%20style%2C%20pastel%20warm%20tones%2C%20clean%20composition%2C%20webtoon%20cover%20design&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    tags: ['职场', '甜宠', '秘密恋爱'],
    chapters_list: [
      { num: 87, title: '意外的告白', date: '2026-08-05' },
      { num: 86, title: '深夜加班', date: '2026-08-03' },
      { num: 85, title: '他的温柔', date: '2026-08-01' },
      { num: 84, title: '心跳加速', date: '2026-07-30' },
      { num: 83, title: '电梯里的秘密', date: '2026-07-28' },
    ],
  },
  {
    id: 'blade-of-destiny',
    title: '命运之刃',
    slug: 'blade-of-destiny',
    author: '朴志浩',
    category: 'fantasy',
    status: '连载中',
    rating: 9.8,
    views: 2380000,
    chapters: 124,
    updatedAt: '2026-08-05',
    description: '在一个魔法与剑并存的世界里，少年凯因意外获得了传说中的命运之刃。这把剑不仅赋予他无穷的力量，也让他背负起拯救世界的使命。与伙伴们一起踏上冒险之旅，揭开隐藏在命运背后的惊天秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20epic%20warrior%20with%20magical%20sword%2C%20mystical%20fantasy%20world%20background%2C%20dramatic%20lighting%2C%20detailed%20illustration%2C%20warm%20golden%20and%20crimson%20tones%2C%20webtoon%20style&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    tags: ['冒险', '魔法', '成长'],
    chapters_list: [
      { num: 124, title: '最终决战', date: '2026-08-05' },
      { num: 123, title: '觉醒之力', date: '2026-08-03' },
      { num: 122, title: '黑暗降临', date: '2026-08-01' },
      { num: 121, title: '命运的召唤', date: '2026-07-30' },
      { num: 120, title: '新的伙伴', date: '2026-07-28' },
    ],
  },
  {
    id: 'my-demon-lover',
    title: '我的恶魔恋人',
    slug: 'my-demon-lover',
    author: '金允儿',
    category: 'fantasy',
    status: '连载中',
    rating: 9.5,
    views: 1890000,
    chapters: 65,
    updatedAt: '2026-08-04',
    description: '普通大学生尹夏恩偶然召唤出了一位恶魔，没想到这位恶魔不仅帅气逼人，还赖在她家不走了。一段人与恶魔之间啼笑皆非的同居生活，夹杂着危险与浪漫，让她的平凡人生彻底失控。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20cover%20art%2C%20handsome%20demon%20male%20character%20with%20dark%20wings%2C%20modern%20girl%20in%20university%20setting%2C%20mysterious%20atmosphere%2C%20dark%20romantic%20style%2C%20deep%20purple%20and%20crimson%20accents%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    tags: ['奇幻爱情', '同居', '搞笑'],
    chapters_list: [
      { num: 65, title: '无法说出口的心意', date: '2026-08-04' },
      { num: 64, title: '危险的夜晚', date: '2026-08-02' },
      { num: 63, title: '恶魔的真面目', date: '2026-07-31' },
      { num: 62, title: '突如其来的吻', date: '2026-07-29' },
      { num: 61, title: '契约的条件', date: '2026-07-27' },
    ],
  },
  {
    id: 'gangster-high',
    title: '黑帮高校',
    slug: 'gangster-high',
    author: '崔胜贤',
    category: 'action',
    status: '连载中',
    rating: 9.4,
    views: 1560000,
    chapters: 92,
    updatedAt: '2026-08-05',
    description: '全国最混乱的高中——大成高中，由各大黑帮势力暗中控制。转学生韩志浩凭借超强战斗力，一步步统一校园，揭开隐藏在背后的巨大阴谋。热血与青春交织的校园动作巨作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20tough%20school%20student%20in%20uniform%20with%20fighting%20stance%2C%20urban%20school%20background%2C%20intense%20dramatic%20lighting%2C%20bold%20illustration%20style%2C%20dark%20and%20warm%20toned%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    tags: ['校园', '热血', '格斗'],
    chapters_list: [
      { num: 92, title: '最后的对决', date: '2026-08-05' },
      { num: 91, title: '兄弟齐心', date: '2026-08-03' },
      { num: 90, title: '幕后黑手', date: '2026-08-01' },
      { num: 89, title: '新的联盟', date: '2026-07-30' },
      { num: 88, title: '绝地反击', date: '2026-07-28' },
    ],
  },
  {
    id: 'tears-of-angel',
    title: '天使之泪',
    slug: 'tears-of-angel',
    author: '韩素英',
    category: 'drama',
    status: '已完结',
    rating: 9.7,
    views: 980000,
    chapters: 48,
    updatedAt: '2026-07-20',
    description: '从小失去双亲的女孩李智恩，在孤儿院长大，却始终保持着天使般纯净的心灵。面对生活的种种磨难，她用善良和坚强温暖了身边的每一个人。一部让人感动落泪的治愈系作品。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20cover%20art%2C%20gentle%20young%20woman%20with%20tearful%20eyes%2C%20soft%20atmospheric%20background%20with%20warm%20light%2C%20emotional%20and%20healing%20mood%2C%20delicate%20watercolor%20illustration%20style%2C%20soft%20pastel%20tones%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    tags: ['治愈', '感动', '成长'],
    chapters_list: [
      { num: 48, title: '天使的微笑（完结）', date: '2026-07-20' },
      { num: 47, title: '最后的告别', date: '2026-07-18' },
      { num: 46, title: '重逢', date: '2026-07-16' },
      { num: 45, title: '真相大白', date: '2026-07-14' },
      { num: 44, title: '新的开始', date: '2026-07-12' },
    ],
  },
  {
    id: 'daily-laugh',
    title: '每天都很好笑',
    slug: 'daily-laugh',
    author: '赵美玲',
    category: 'comedy',
    status: '连载中',
    rating: 9.3,
    views: 1120000,
    chapters: 156,
    updatedAt: '2026-08-05',
    description: '四个性格迥异的闺蜜，在同一座城市里发生的爆笑日常。从职场糗事到感情乌龙，每一话都让你笑到肚子疼。轻松愉快的四格漫画风，是减压放松的不二之选。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20cover%20art%2C%20four%20funny%20female%20friends%20laughing%20together%2C%20bright%20colorful%20background%2C%20cheerful%20and%20playful%20mood%2C%20cute%20illustration%20style%2C%20vibrant%20warm%20colors%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    tags: ['日常', '搞笑', '闺蜜'],
    chapters_list: [
      { num: 156, title: '相亲大作战', date: '2026-08-05' },
      { num: 155, title: '老板不在的一天', date: '2026-08-04' },
      { num: 154, title: '减肥的执念', date: '2026-08-03' },
      { num: 153, title: '快递乌龙事件', date: '2026-08-02' },
      { num: 152, title: '闺蜜的男朋友', date: '2026-08-01' },
    ],
  },
  {
    id: 'the-last-witness',
    title: '最后的目击者',
    slug: 'the-last-witness',
    author: '郑道贤',
    category: 'thriller',
    status: '连载中',
    rating: 9.6,
    views: 870000,
    chapters: 42,
    updatedAt: '2026-08-04',
    description: '检察官朴泰俊接手了一桩看似普通的谋杀案，却发现自己成为了凶手的下一个目标。每一条线索都指向一个更大的阴谋，而他身边的每一个人似乎都隐藏着不为人知的秘密。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20cover%20art%2C%20mysterious%20detective%20character%20in%20dark%20alley%2C%20suspenseful%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20intense%20gritty%20illustration%20style%2C%20dark%20moody%20tones%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    tags: ['悬疑', '推理', '犯罪'],
    chapters_list: [
      { num: 42, title: '凶手的真面目', date: '2026-08-04' },
      { num: 41, title: '最后的线索', date: '2026-08-02' },
      { num: 40, title: '第二个受害者', date: '2026-07-31' },
      { num: 39, title: '监控录像', date: '2026-07-29' },
      { num: 38, title: '匿名信', date: '2026-07-27' },
    ],
  },
  {
    id: 'cherry-blossom-love',
    title: '樱花之恋',
    slug: 'cherry-blossom-love',
    author: '尹恩惠',
    category: 'bl',
    status: '连载中',
    rating: 9.5,
    views: 1030000,
    chapters: 55,
    updatedAt: '2026-08-05',
    description: '在樱花盛开的校园里，两位少年相遇了。内向安静的图书管理员成宇，与阳光开朗的篮球队长贤秀，从最初的误会到逐渐靠近，一段青涩美好的校园恋爱悄然绽放。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20romance%20cover%20art%2C%20two%20handsome%20young%20men%20under%20cherry%20blossom%20trees%2C%20school%20campus%20background%2C%20gentle%20spring%20atmosphere%2C%20soft%20romantic%20illustration%20style%2C%20pink%20and%20warm%20pastel%20tones%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    tags: ['校园', '纯爱', '青春'],
    chapters_list: [
      { num: 55, title: '樱花树下的约定', date: '2026-08-05' },
      { num: 54, title: '鼓起勇气', date: '2026-08-03' },
      { num: 53, title: '深夜的电话', date: '2026-08-01' },
      { num: 52, title: '图书馆的秘密', date: '2026-07-30' },
      { num: 51, title: '篮球场上的告白', date: '2026-07-28' },
    ],
  },
  {
    id: 'revenge-queen',
    title: '复仇女王',
    slug: 'revenge-queen',
    author: '孙艺珍',
    category: 'drama',
    status: '连载中',
    rating: 9.6,
    views: 1670000,
    chapters: 78,
    updatedAt: '2026-08-04',
    description: '被最信任的闺蜜和未婚夫联手背叛后，沈秀雅失去了一切。三年后，她以全新的身份归来，展开了一场精心策划的复仇。但当她发现真相远比想象中复杂时，复仇之路变得扑朔迷离。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20revenge%20cover%20art%2C%20elegant%20powerful%20woman%20in%20luxury%20setting%2C%20dramatic%20glamorous%20atmosphere%2C%20intense%20expression%2C%20sophisticated%20illustration%20style%2C%20deep%20red%20and%20dark%20accents%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    tags: ['复仇', '豪门', '逆袭'],
    chapters_list: [
      { num: 78, title: '最后的对决', date: '2026-08-04' },
      { num: 77, title: '意外的盟友', date: '2026-08-02' },
      { num: 76, title: '照片里的秘密', date: '2026-07-31' },
      { num: 75, title: '豪门晚宴', date: '2026-07-29' },
      { num: 74, title: '身份暴露', date: '2026-07-27' },
    ],
  },
  {
    id: 'cat-cafe-diary',
    title: '猫咪咖啡馆日记',
    slug: 'cat-cafe-diary',
    author: '林秀晶',
    category: 'daily',
    status: '连载中',
    rating: 9.2,
    views: 720000,
    chapters: 103,
    updatedAt: '2026-08-03',
    description: '辞去高压工作后，柳真在一条安静的小巷里开了一家猫咪咖啡馆。每天与可爱的猫咪和形形色色的客人相处，她找到了生活真正的意义。温暖治愈的日常故事，献给每一个疲惫的你。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20cat%20cafe%20with%20cute%20cats%20and%20warm%20interior%2C%20relaxing%20atmosphere%2C%20gentle%20illustration%20style%2C%20soft%20warm%20lighting%2C%20pastel%20cream%20tones%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    tags: ['日常', '治愈', '猫咪'],
    chapters_list: [
      { num: 103, title: '新来的小猫咪', date: '2026-08-03' },
      { num: 102, title: '雨天的客人', date: '2026-08-01' },
      { num: 101, title: '猫咪的生日会', date: '2026-07-30' },
      { num: 100, title: '第一百话纪念', date: '2026-07-28' },
      { num: 99, title: '深夜急诊', date: '2026-07-26' },
    ],
  },
  {
    id: 'moonlight-garden',
    title: '月光花园',
    slug: 'moonlight-garden',
    author: '都雅拉',
    category: 'gl',
    status: '连载中',
    rating: 9.4,
    views: 680000,
    chapters: 36,
    updatedAt: '2026-08-02',
    description: '在首尔近郊的一座花园里，花艺师智敏遇到了来学插花的公司职员秀雅。两个完全不同世界的女人，在花香与月光中慢慢靠近。一段温柔细腻、如同花瓣般美好的爱情故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20romance%20cover%20art%2C%20two%20beautiful%20women%20in%20moonlit%20flower%20garden%2C%20romantic%20ethereal%20atmosphere%2C%20soft%20dreamy%20illustration%20style%2C%20silver%20and%20lavender%20tones%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    tags: ['花园', '治愈', 'GL'],
    chapters_list: [
      { num: 36, title: '月光下的告白', date: '2026-08-02' },
      { num: 35, title: '花语', date: '2026-07-31' },
      { num: 34, title: '雨天约会', date: '2026-07-29' },
      { num: 33, title: '意外的礼物', date: '2026-07-27' },
      { num: 32, title: '深夜花房', date: '2026-07-25' },
    ],
  },
  {
    id: 'time-traveler',
    title: '时间旅行者',
    slug: 'time-traveler',
    author: '江南赫',
    category: 'fantasy',
    status: '已完结',
    rating: 9.9,
    views: 3200000,
    chapters: 200,
    updatedAt: '2026-06-15',
    description: '物理学家姜宇镇意外发明了时间机器，他穿梭于各个时代，试图改变过去的悲剧。然而每一次改变都带来了意想不到的连锁反应。当他发现自己的存在本身就是时间悖论的一部分时，一切都已经太迟了。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20fantasy%20cover%20art%2C%20time%20traveler%20character%20with%20clock%20motif%2C%20surreal%20time%20warp%20background%2C%20mysterious%20atmosphere%2C%20detailed%20illustration%20style%2C%20golden%20and%20teal%20contrast%2C%20webtoon%20cover&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    tags: ['科幻', '穿越', '悬疑'],
    chapters_list: [
      { num: 200, title: '时间的尽头（完结）', date: '2026-06-15' },
      { num: 199, title: '最终的选择', date: '2026-06-13' },
      { num: 198, title: '真相', date: '2026-06-11' },
      { num: 197, title: '悖论', date: '2026-06-09' },
      { num: 196, title: '回到原点', date: '2026-06-07' },
    ],
  },
];

export const banners = [
  {
    id: 'banner-1',
    comicId: 'time-traveler',
    title: '时间旅行者 - 全网评分最高韩漫',
    subtitle: '9.9分神作，穿越时空的震撼之旅',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20time%20travel%20banner%20art%2C%20mysterious%20time%20portal%20with%20clock%20gears%2C%20dramatic%20golden%20lighting%2C%20fantasy%20sci-fi%20atmosphere%2C%20cinematic%20composition%2C%20warm%20golden%20and%20deep%20teal%20contrast%2C%20webtoon%20promotional%20banner%20design&width=1400&height=600&seq=banner-hero-01&orientation=landscape',
  },
  {
    id: 'banner-2',
    comicId: 'blade-of-destiny',
    title: '命运之刃 - 年度最燃奇幻大作',
    subtitle: '魔法与剑的史诗冒险，热更连载中',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20manhwa%20fantasy%20banner%20art%2C%20heroic%20warrior%20with%20flaming%20sword%20in%20mystical%20landscape%2C%20dramatic%20cinematic%20lighting%2C%20grand%20epic%20scale%2C%20warm%20crimson%20and%20gold%20tones%2C%20webtoon%20promotional%20banner%20design&width=1400&height=600&seq=banner-hero-02&orientation=landscape',
  },
  {
    id: 'banner-3',
    comicId: 'secret-relationship',
    title: '秘密关系 - 甜蜜职场恋曲',
    subtitle: '9.6分人气恋爱韩漫，心动不停',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20banner%20art%2C%20elegant%20couple%20in%20modern%20office%20cityscape%2C%20warm%20romantic%20sunset%20lighting%2C%20soft%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20pink%20and%20golden%20warm%20tones%2C%20webtoon%20promotional%20banner%20design&width=1400&height=600&seq=banner-hero-03&orientation=landscape',
  },
];

export const stats = {
  totalComics: '12,000+',
  totalChapters: '500,000+',
  dailyReaders: '800,000+',
  satisfaction: '99.2%',
};